module.exports = __webpack_public_path__ + "media/images/stream_preview_landscape-fadb265128e01e9e8bd27b844382ff18.png";